<template>
  <div class="protocol-page">
    <div class="protocol-content">
     <p>
            </p><p class="p" align="center" style="text-indent:21.0000pt;text-align:center;padding-top: 5%;">
                APP用户协议
            </p>
            <p class="p" style="text-indent:21.0000pt;">
                <span>欢迎阅读《</span><span>APP用户协议》(以下简称“本协议”)。本协议阐述之条款和条件适用于您（以下简称“用户”）使用APP的各种产品和服务。</span>
            </p>
            <p class="p" style="text-indent:21.0000pt;">
                <b>1. 服务协议的确认</b>
            </p>
            <p class="p" style="text-indent:21.0000pt;">
                <span>用户同意本协议的全部条款并按照合宙定位APP上的提示完成全部的注册程序。本协议包括但不限于本协议、合宙定位APP现有的及不时更新的或新发布的服务产品相对应的服务协议和《隐私权政策》以及其他各项规则、制度等。用户勾选《APP用户协议》即表示用户同意接受本协议及合宙定位APP相关服务协议的内容，如合宙定位APP相关服务协议的生效条款与本协议生效条款存在冲突，以本条规定为准。 </span>
            </p>
            <p class="p" style="text-indent:21.0000pt;">
                <span>用户注册并使用合宙定位APP服务，表明用户已确认本协议不受您所属/所在国家或地区法律的排斥。否则，由此致使的一切责任由用户承担，并赔偿可能发生的费用且使上海合宙通信科技有限公司由免于一切直接或间接的责任。 </span>
            </p>
            <p class="p" style="text-indent:21.0000pt;">
                <b>2. 服务与支持</b>
            </p>
            <p class="p" style="text-indent:21.0000pt;">
                <span>合宙通信公司为用户提供的服务与支持内容在合宙定位APP的服务与支持定义，合宙通信公司有权改变服务与支持的内容，以小狗通信APP最新公布的内容为准。 </span>
            </p>
            <p class="p" style="text-indent:21.0000pt;">
                <b>3. 服务变更、中断或终止</b>
            </p>
            <p class="p" style="text-indent:21.0000pt;">
                3.1 鉴于网络服务的特殊性（包括但不限于不可抗力、网络稳定性、系统稳定性、技术故障、用户所在位置、用户关机、用户手机病毒或恶意的网络攻击行为及其他任何技术、互联网络、通信线路、内容侵权等原因），用户同意，合宙通信公司有权随时中断或终止部分或全部合宙定位APP服务，合宙通信公司将尽可能及时以合理方式通知用户，并尽可能在第一时间对此进行修复。但对因此导致用户不能发送和接受阅读信息、或接发错信息，合宙通信公司不承担任何责任，用户须承担以上风险。
            </p>
            <p class="p" style="text-indent:21.0000pt;">
                3.2 用户理解，合宙通信公司需要定期或不定期地对提供合宙定位APP服务的平台或相关设备进行检修和维护，如因此类情况而造成服务在合理期间内的中断，合宙通信公司将尽可能事先通知，但无需为此承担任何责任。
            </p>
            <p class="p" style="text-indent:21.0000pt;">
                3.3 用户提供的个人资料不真实、用户违反法律法规国家政策或本协议规定的使用规则，合宙通信公司有权随时中断或终止向用户提供本协议项下的合宙定位APP服务，而无需对用户或任何第三方承担任何责任。
            </p>
            <p class="p" style="text-indent:21.0000pt;">
                <b>4. 使用规则</b>
            </p>
            <p class="p" style="text-indent:21.0000pt;">
                4.1 用户在申请注册合宙定位APP时，根据系统需要提供准确的个人资料（包括姓名、性别、出生年月、电话、邮箱等），如个人资料有任何变动，必须及时更新。因用户提供资料的真实性问题导致协议双方或第三方的任何损失均由用户承担。
            </p>
            <p class="p" style="text-indent:21.0000pt;">
                4.2 用户注册成功后，将获得一个合宙定位APP帐号及由用户设置的密码，该用户帐号和密码由用户负责保管；用户应当对该用户帐号所有行为负相关法律责任。
            </p>
            <p class="p" style="text-indent:21.0000pt;">
                <span>用户在使用合宙定位APP服务过程中，必须遵循以下原则:</span>
            </p>
            <p class="p" style="text-indent:21.0000pt;">
                (1) 遵守中国有关的法律和法规；
            </p>
            <p class="p" style="text-indent:21.0000pt;">
                (2) 不得为任何非法目的而使用合宙定位APP服务；
            </p>
            <p class="p" style="text-indent:21.0000pt;">
                (3) 遵守所有与网络服务有关的网络协议、规定和程序；
            </p>
            <p class="p" style="text-indent:21.0000pt;">
                (4) 不得利用合宙定位APP服务系统进行任何可能对互联网的正常运转造成不利影响的行为；
            </p>
            <p class="p" style="text-indent:21.0000pt;">
                (5) 不得利用合宙定位APP进行任何不利于合宙通信公司的行为。
            </p>
            <p class="p" style="text-indent:21.0000pt;">
                4.3 用户不得使用合宙定位APP制作、上传、发送、传播敏感信息和违反国家法律制度的信息，包括但不限于下列信息:
            </p>
            <p class="p" style="text-indent:21.0000pt;">
                (1) 反对宪法所确定的基本原则的；
            </p>
            <p class="p" style="text-indent:21.0000pt;">
                (2) 危害国家安全，泄露国家秘密，颠覆国家政权，破坏国家统一的；
            </p>
            <p class="p" style="text-indent:21.0000pt;">
                (3) 损害国家荣誉和利益的；
            </p>
            <p class="p" style="text-indent:21.0000pt;">
                (4) 煽动民族仇恨、民族歧视，破坏民族团结的；
            </p>
            <p class="p" style="text-indent:21.0000pt;">
                (5) 破坏国家宗教政策，宣扬邪教和封建迷信的；
            </p>
            <p class="p" style="text-indent:21.0000pt;">
                (6) 散布谣言，扰乱社会秩序，破坏社会稳定的；
            </p>
            <p class="p" style="text-indent:21.0000pt;">
                (7) 散布淫秽、色情、赌博、暴力、凶杀、恐怖或者教唆犯罪的；
            </p>
            <p class="p" style="text-indent:21.0000pt;">
                (8) 侮辱或者诽谤他人，侵害他人合法权益的；
            </p>
            <p class="p" style="text-indent:21.0000pt;">
                (9) 含有法律、行政法规禁止的其他内容的。
            </p>
            <p class="p" style="text-indent:21.0000pt;">
                4.4 用户同意在任何情况下不使用其他用户的帐号或密码。在您怀疑他人在使用您的帐号或密码时，您同意立即通知合宙通信公司。
            </p>
            <p class="p" style="text-indent:21.0000pt;">
                4.5 用户有权更改、删除在合宙定位APP中的个人资料、注册信息及传送内容等，但删除有关信息的同时也会删除任何您储存在系统中的文字和图片。用户需承担该风险。
            </p>
            <p class="p" style="text-indent:21.0000pt;">
                4.6 如因用户违反本协议中的任何条款，合宙通信公司有权依据本协议终止对违约用户合宙定位APP帐号提供服务。
            </p>
            <p class="p" style="text-indent:21.0000pt;">
                4.7 我们会将所收集到的信息用于大数据分析。例如，我们将收集到的信息用于分析形成不包含任何个人信息的统计类服务和产品。我们可能对外公开并与我们的合作伙伴分享经统计加工后不含身份识别内容的大数据分析信息。
            </p>
            <p class="p" style="text-indent:21.0000pt;">
                <b>&nbsp;</b>
            </p>
            <p class="p" style="text-indent:21.0000pt;">
                <b>5. 知识产权</b>
            </p>
            <p class="p" style="text-indent:21.0000pt;">
                5.1 合宙通信公司提供合宙定位APP服务中所包含的任何文本、图片、标识、音频、视频资料均受著作权、商标权、专利权及其他财产权法律的保护。
            </p>
            <p class="p" style="text-indent:21.0000pt;">
                5.2 未经相关权利人和合宙通信公司的同意，上述资料均不得以任何方式被展示于其他任何第三方平台或被用于其他任何商业目的；用户不得擅自复制、修改、编纂上述内容、或创造与内容有关的衍生产品。
            </p>
            <p class="p" style="text-indent:21.0000pt;">
                <b>6. 隐私保护</b>
            </p>
            <p class="p" style="text-indent:21.0000pt;">
                6.1 合宙通信公司将采取各种制度、安全技术和程序等措施来保护用户隐私和个人数据不被未经授权的访问、使用或泄漏。
            </p>
            <p class="p" style="text-indent:21.0000pt;">
                6.2 用户在注册合宙定位APP帐号或使用合宙定位APP服务的过程中，需要提供一些必要的信息，例如：姓名、电话、邮箱、性别、出生年月、名称、注册地址、注册号等。为向用户提供帐号注册服务或进行用户身份识别，需要用户填写手机号码；部分功能需要用户授权使用用户的相机或相册；部分功能需要用户授权访问用户的手机通讯录等；部分功能需要用户授权访问用户的位置信息等。若用户不授权或提供的信息不完整，则无法使用本服务或在使用过程中受到限制。用户授权提供的信息，合宙通信公司承诺将采取措施保护用户的个人信息安全。
            </p>
            <p class="p" style="text-indent:21.0000pt;">
                6.3 为了向用户提供更好的用户体验和提高合宙定位APP的服务质量，合宙通信公司将可能会收集使用或向第三方提供用户的非个人隐私信息。合宙通信公司将对该第三方使用用户个人数据的行为进行监督和管理，尽一切可能努力保护用户个人信息的安全。
            </p>
            <p class="p" style="text-indent:21.0000pt;">
                <b>7. 免责声明</b>
            </p>
            <p class="p" style="text-indent:21.0000pt;">
                7.1 用户在使用合宙定位APP服务的过程中应遵守国家法律法规及政策规定，对其所制作、上传、发送、传播的信息和内容承担任何法律责任，与合宙通信公司无关。
            </p>
            <p class="p" style="text-indent:21.0000pt;">
                7.2 合宙定位APP在其页面上向用户显示、推送的任何信息和内容如系合宙通信公司利用技术手段根据用户指令从互联网任何第三方网站搜索、定位、匹配后推荐给用户而非合宙通信公司单方制作的，则该显示、推送的信息和内容并不代表合宙通信公司及合宙定位APP的观点，合宙通信公司并不对上述信息的准确性和正确性负责。
            </p>
            <p class="p" style="text-indent:21.0000pt;">
                7.3合宙通信公司提供合宙定位APP服务中所包含的任何文本、图片、标识、音频、视频资料均为教学用途，不涉及任何实体物品的商业活动。
            </p>
            <p class="p" style="text-indent:21.0000pt;">
                7.4合宙定位APP在其页面上向用户显示、推送的任何信息和内容如存在侵权任何第三方知识产权的嫌疑，权利人和相关利害关系人应当向合宙通信公司发出权利通知，合宙通信公司经过核实后根据有关法律法规有权采取包括但不限于断开该侵权内容的链接或删除并停止传输该侵权内容，但合宙通信公司并不对该侵权内容承担法律责任。
            </p>
            <p class="p" style="text-indent:21.0000pt;">
                7.5用户违反本协议的规定，导致或产生的任何第三方主张的任何索赔、要求或损失，包括合理的律师费，用户同意赔偿合宙通信公司，使之免受损害。
            </p>
            <p class="p" style="text-indent:21.0000pt;">
                <b>8. 其他条款</b>
            </p>
            <p class="p" style="text-indent:21.0000pt;">
                8.1 合宙通信公司有权随时修改本协议的任何条款，一旦本协议的内容发生变动，合宙通信公司将会在合宙定位APP平台中公布修改后的协议内容或通过其他适当方式向用户公布修改内容。用户不同意上述修改内容，有权选择停止使用合宙定位APP服务，但用户继续使用，则视为接受合宙通信公司对本协议相关条款的修改。
            </p>
            <p class="p" style="text-indent:21.0000pt;">
                8.2 本《协议》所定的任何条款无论因何种原因部分或全部无效或不具有执行力，本协议的其余条款仍应有效并具备约束力。
            </p>
            <p class="p" style="text-indent:21.0000pt;">
                8.3 本协议的订立、执行和解释及纠纷的解决均应适用中华人民共和国法律并受中华人民共和国法院管辖。如双方就本协议内容或执行发生任何纠纷或争议，首先应友好协商解决，协商不成的，任何一方均可向合宙通信公司所在地的有管辖权的人民法院提起诉讼。
            </p>
            <p class="p" style="text-indent:21.0000pt;">
                8.4 本协议的版权归合宙通信公司所有，本协议各项条款内容的最终解释权及修改权归合宙通信公司所有。
            </p>
            <p class="MsoNormal">
                &nbsp;
            </p>
        <p></p>
        <p>
            <br>
        </p>
    </div>
  </div>
</template>

<script setup lang="ts">
import { useRouter } from 'vue-router'

const router = useRouter()

const goBack = () => {
  router.back()
}
</script>

<style scoped lang="scss">
.protocol-page {
  width: 100%;
  height: 100vh;
  display: flex;
  flex-direction: column;
//   background: #fff;  //不给这个页面背景色，跟随全局模式
}

.protocol-header {
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 16px;
  border-bottom: 1px solid #eee;
  background: #fff;
  z-index: 10;
}

.back-button {
  position: absolute;
  left: 16px;
  display: flex;
  align-items: center;
  gap: 4px;
  padding: 8px 12px;
  background: transparent;
  border: none;
  color: var(--color-primary, #409eff);
  font-size: 16px;
  cursor: pointer;
  transition: opacity 0.2s;

  &:hover {
    opacity: 0.8;
  }

  &:active {
    opacity: 0.6;
  }
}

.title {
  margin: 0;
  font-size: 18px;
  font-weight: 600;
  color: #333;
}

.protocol-content {
  flex: 1;
  overflow: auto;
  padding: 0px 20px;
}
</style>
